import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const DigiLockerCallback = () => {
    const location = useLocation();
    const hasSentRef = useRef(false);

    useEffect(() => {
        if (hasSentRef.current) return;
        hasSentRef.current = true;

        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get('code');
        const state = queryParams.get('state');

        if (window.opener) {
            if (code) {
                window.opener.postMessage({
                    type: 'DIGILOCKER_CODE',
                    code,
                    state
                }, '*');
            } else {
                window.opener.postMessage({
                    type: 'DIGILOCKER_ERROR',
                    error: 'DigiLocker permission denied or code missing.'
                }, '*');
            }
        }

        // Close popup window immediately
        try {
            window.close();
        } catch (e) {
            console.error('Failed to close popup:', e);
        }
    }, [location]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            backgroundColor: '#f8fafc',
            color: '#475569',
            textAlign: 'center',
            padding: '20px'
        }}>
            <div>
                <div className="spinner-border text-primary mb-3" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h4 style={{ fontWeight: '600', color: '#0f172a', fontSize: '1.1rem' }}>Completing DigiLocker Authorization...</h4>
                <p style={{ fontSize: '0.875rem', color: '#64748b' }}>Closing popup and returning to dashboard...</p>
            </div>
        </div>
    );
};

export default DigiLockerCallback;
